<template>
  <div class="room"
    v-if="room.positionInMap"
    :class="{
      'rollover': currentRoom === room.roomName._slug,
      'clicked': (visitedRooms.includes(room.roomName._slug)),
      'active': ($route.params.roomName === room.roomName._slug)
    }"
    :style="{
      'left': parsePosition(room.positionInMap).x + '%',
      'top': parsePosition(room.positionInMap).y + '%'
    }"
    @click.stop="onChangeRoom(floor, room.roomName)"
    @mouseover="$emit('roomOver', room.roomName.enTitle); isRollover = true"
    @mouseout="$emit('roomOver', ''); isRollover = false"
    >
    <transition name="slide">
      <div v-if="isActive && !$root.platform.mobile && (room.roomName.previewImage || room.roomName.backgroundImage360)"
        :key="room.roomName._slug"
        v-show="isRollover || currentRoom === room.roomName._slug"
        class="room-image">
        <img width="300"
          height="200"
          :src="room.roomName.previewImage ? '/media/'+room.roomName.previewImage.id : '/media/'+room.roomName.backgroundImage360.id"/>
      </div>
    </transition>
    <div class="ring"></div>
    <div class="dot"></div>
    <p class="room-name">{{room.roomName.roomTitle}}</p>
  </div>
</template>

<script>
export default {
  name: 'MapRoomDot',

  data () {
    return {
      isRollover: false
    }
  },
  props: {
    isActive: {
      type: Boolean,
      required: false
    },
    floor: {
      type: Object,
      required: true
    },
    room: {
      type: Object,
      required: true
    },
    visitedRooms: {
      type: Array,
      require: true
    },
    currentRoom: {
      type: String,
      require: false
    }
  },

  methods: {
    onChangeRoom (floor, room) {
      this.$emit('roomClick', floor._slug, room)
    },
    parsePosition (posString) {
      return {
        x: posString.split(',')[0],
        y: posString.split(',')[1]
      }
    }
  }
}

</script>

<style lang="scss" scoped>
.room {
  position: absolute;
  cursor: pointer;
  z-index: 1;

  .room-image {
    position: absolute;
    transform: translate(-50%, -50%);
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.5s;
    overflow: hidden;
  }

  .dot {
    position: absolute;
    width: 12px;
    height: 12px;
    border-radius: 12px;
    // border: 1px solid $c-black;
    background-color: $c-white-50;
    transition: width 1s, height 1s;
    transform: translate(-50%, -50%);

    @include breakpoint('sm-and-down') {
      width: 8px;
      height: 8px;
    }
  }

  .ring {
    width: 0;
    height: 0;
    border: 1px solid $c-black;
    border-radius: 28px;
    position: absolute;
    opacity: 0;
    transform: translate(-50%, -50%);
    transition: width 1s, height 1s;
  }

  &:hover,
  &.rollover {
    .room-image {
      width: 200px;
      height: auto;
      opacity: 0.8;
    }
  }

  &:hover,
  &.active,
  &.rollover {
    z-index: 2;

    .dot {
      background-color: $c-black !important;
      width: 8px;
      height: 8px;
    }

    .ring {
      opacity: 1;
      width: 28px;
      height: 28px;
      background-color: $c-white;
      border-style: none;
    }
  }

  &.clicked {
    background-color: #ff0;
  }

  .room-name {
    width: 100px;
    text-align: center;
    transform: translate(-50%, -100%);
    background-color: $c-white;
    display: none;
    transition: opacity 0.5s;
  }
}

.slide-enter-active,
.slide-leave-active {
  transition: all 1s !important;
}

.slide-enter,
.slide-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0 !important;
  transform: translate(-50%, -45%) !important;
  // border-radius: 300px;
}
</style>
